<template>
    <div>
        <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="20">
                <div class="title">
                    <h1>Honeyjar</h1>
                </div>
                <div class="video">
                    <div class="">
                        <video src="../assets/project8.mp4" controls muted >
                        OMG! Where is my video?
                        </video>
                    </div>
                </div>
                <div class="paper_published">
                    First Prize in the 4th China Graduate Mobile Application Design Innovation Competition (Project Leader)
                </div>
                <div class="abstract">
                    Honeyjar is a novel virtual savings assistant in the era of e-payment, which provides a solution to help children establish financial awareness and satisfy parent's need for money education.
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/主效果图.jpg.webp">
                </div>
            </el-col>
            <el-col :span="12">
                <div class="sub-title">
                    Design innovation points                </div>
                <div class="text">
                    (1) Construction of children’s consumption concept:
                    <br><br>a. virtual money, non-virtual experience: Give a sense of ritual to the storage of each coin, and a real sense of virtual money through AR animation.
                    <br><br>  b. AI deep learning: children can interact with Honeyjar through voice in daily life. Honeyjar will analyze and learn children's consumption preferences by AI deep learning algorithms and give suggestions for consumption to encourage children to consume independently and reasonably.
                   <br><br> (2) Money education assistant:
                    <br><br>a. A context of money education: Through sound and light feedback, the time for giving pocket money is extended to provide a context of money education.
                    <br><br>b. Parents can learn children's financial reports and consumption habits through the App. It also can provide education suggestions;
                    <br><br>(3) Get children interested: Honeyjar can be attached to various dolls to create various fun experiences.
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="12">
                <div class="sub-title">
                   Painpoints
                </div>
                <div class="text">
                    China is now in the era of mobile payment. Children born after 2010 are surrounded by mobile payments ever since they opened the eyes. There is no denying that mobile payment brings great convenience to our lives. However, such a simple way to pay is undoubtedly not good for cultivation of money concept of children, who even have no idea what money is.
                   <br><br> For parents, on the other hand, they can no longer help their children cultivate the concept of money by traditional means due to the lack of cash payments. What’s worse, the limited time during payment by phone leads to the difficulty of having a chance of money education for children.
                </div>
            </el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/poster1.jpg.webp">
                </div>

            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="8">
                <div class="picture">
                    <img src="../assets/poster3.jpg.webp">
                </div>
            </el-col>
            <el-col :span="12">
                <div class="sub-title">
                    Potential and Expandability                </div>
                <div class="text">
                    We hope to fill the gaps in children's money education in the era of e-payment through Honeyjar and help children build a correct view of money and more profound values.
                    <br><br>   From the product level, we hope to develop smarter voice interaction functions in the future, making full use of the characteristics of deep learning technology to empower products and achieve more intelligent and convenient product upgrades.
                    <br><br>   From the perspective of the business model, in the market of children's money education products, most of them are only mobile apps, and parents are always sensitive to children's contact with mobile phones. Therefore, a mobile app with a smart terminal product will be more acceptable. And this market is blank. In the future, our products can be linked with mobile payment products such as Alipay or WeChat wallet to create children's“Alipay” or “WeChat wallet”. At the same time, our online store of products can invite merchants to settle in or connect to the e-commerce platform.
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>

            <el-col :span="20">
                <div class="picture">
                    <img src="../assets/poster4.jpg.webp">
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "Project7"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .paper_published{
        margin-top: 24px;
        font-size: 15px;
        color: #333;
        font-weight: 400;
        text-align: justify;
        line-height: 1.9;
        border-bottom: 1px solid #333;
        padding-bottom: 6px;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>